import*as o from"react";var a=Boolean(globalThis?.document)?o.useLayoutEffect:()=>{};export{a as useLayoutEffect};
//# sourceMappingURL=index.js.map
